export default "__VITE_ASSET__DHWQLVaB__"